import * as React from 'react';

export const GalleryContext = React.createContext();
